(() => {
    /* FILTER FOR SEARCH INTERFACE */
    class Filter {
        constructor(Search) { this.Interface = Search; }
        /* Constants */
        get filters()   { return this.Interface.filters }
        get URL_PARAM_SEPARATOR()   { return '|' }
        get SORT_ORDER_ASC()        { return 'asc' }
        get SORT_ORDER_DESC()       { return 'desc' }
        get SORT_BY_RELEVANCE()     { return 'relevance' }
        get SORT_BY_POPULARITY()    { return 'popularity' }
        get SORT_BY_CREATION()      { return 'id' }
        get SORT_BY_NAME()          { return 'title' }
        get SORT_DEFAULT_BY()       { return this.SORT_BY_POPULARITY }
        get SORT_DEFAULT_ORDER()    { return this.SORT_ORDER_ASC }
        get SORT_TYPES()            { return [
            this.SORT_BY_RELEVANCE, this.SORT_BY_POPULARITY, this.SORT_BY_CREATION, this.SORT_BY_NAME,
        ]}

        /* Getters */
        /**
         * Return array with all visible filters
         * @return {[]}
         */
        get visible() {
            /* Set visible all allowed types */
            let visible = [];
            let allow   = this.alwaysVisible;
            for (let key in this.filters) {
                if (this.filters[key].visibility || allow.indexOf(key) >= 0) {
                    visible.push(key);
                }
            }
            return visible;
        }

        /**
         * Check if a string is a valid sort type
         * @param type
         * @return {boolean}
         */
        isSortType(type) {
            return this.SORT_TYPES.includes(type);
        }

        /**
         * Return all possible filters (not in result) that belong to a unique/radio group
         * @return {[]}
         */
        get alwaysVisible() {
            let allow = [];
            let result = this.Interface.data;
            for (let key in result) {
                let item = result[key];
                if (this.Interface.isNotFilterRelevant(item.type)) continue;
                for (let key in item.filter) {
                    if (this.Interface.filters[key] === undefined) continue;
                    if (!this.Interface.filterGroups[this.Interface.filters[key].group].unique) continue;
                    if (allow.indexOf(key) === -1) allow.push(key);
                }
            }
            return allow;
        }

        /**
         * Return array with all selected filters
         * @return {[]}
         */
        get selected() {
            let selected = [];
            for (let key in this.filters) if (this.filters[key].selected) selected.push(key);
            return selected;
        }

        /**
         * Return array with all combiable and active filters
         * @return {[]}
         */
        get combine() {
            const values = [];
            for (let key in this.filters)
                if (this.filters[key].selected && this.filters[key].condition === 'combine') values.push(key);
            return values;
        }

        get groups() {
            return this.Interface.metadata[1];
        }

        get featured() {
            const groups    = [];
            const featured  = [];
            for (const i in this.groups) if (this.groups[i].featured === true) groups.push(i);
            for (const i in this.filters)
                if (this.filters[i].featured === true || groups.includes(this.filters[i].group)) featured.push(i);
            return featured;
        }

        isSelected(identifier) {
            return this.filters[identifier]['selected'];
        }

        isFeatured(identifier) {
            return this.featured.includes(identifier);
        }

        /**
         * Mark as selected a given filter
         * @param filter
         * @param reset
         * @return {Filter}
         */
        add(filter, reset = false) {
            if (reset) this.reset();
            if (this.filters[filter] !== undefined) {
                this.filters[filter]['selected'] = true;
            } else {
                console.log('Filter not found in metadata');
            }
            this.Interface.update();
            return this;
        }

        /**
         * Mark as not selected a given filter
         * @param filter
         * @return {Filter}
         */
        remove(filter) {
            if (this.filters[filter] !== undefined)
                this.filters[filter]['selected'] = false;
            this.Interface.update();
            return this;
        }

        /**
         * Reset all given filters
         * @return {Filter}
         */
        reset() {
            for (let filter in this.filters) {
                this.filters[filter].selected   = false;
                this.filters[filter].visibility = this.filters[filter].visible;
            }
            this.Interface.update();
            return this;
        }

        /**
         * Format: {brand}/{query}/{sort|direction}/{filters}/{filters...}
         * @param string
         */
        import(string) {
            let params = string.split('/').filter(param => param !== '');

            // get the sort
            if (params.length) {
                let sort = params[0].split(this.URL_PARAM_SEPARATOR);
                if (this.isSortType(sort[0])) {
                    this.Interface.setSort(sort[0], sort[1] || this.SORT_DEFAULT_ORDER);
                    params.splice(0, 1);
                }
            }

            // get the search & params
            let values = {
                'query':    null,
                'params':   [],
            };
            for (const key in params) {
                let filter = params[key];
                if (filter === 'null') continue;
                if (this.Interface.filters[filter] !== undefined) {
                    values.params.push(filter);
                } else {
                    values.query = filter;
                }
            }
            this.Interface.setQuery(values.query);
            values.params.forEach (
                param => this.Interface.Filter.add(param)
            );
        }

        /**
         * Format: {brand}/{query}/{sort|direction}/{filters}/{filters...}
         * @param string
         */
        export() {
            var active          = [];
            let data            = this.Interface.get;
            /* Do not setAddress if not allowed */
            for (let filter in this.Interface.filters)
                if (this.Interface.filters[filter].selected === true) {
                    active.push(filter);
                }
            active.sort();
            if (data.query) active.unshift(encodeURI(data.query));
            if (data.sort.by !== this.SORT_DEFAULT_BY)
                active.unshift([data.sort.by, data.sort.order].join(this.URL_PARAM_SEPARATOR));
            if (data.brand) active.unshift(data.brand);
            return active.join('/');
        }

        groupHasItems(key) {
            if (key === 'brands') return true;
            for (let filter in this.filters) {
                if (this.filters[filter].group === key) {
                    if (this.Interface.data.find(item => item.filter[filter])) return true;
                }
            }
            return false;
        }

        hasFeaturedFilter() {
            return this.countFilters(true) > 0;
        }

        getFeaturedFilter() {
            return this.filters[this.featured.find(i => this.isSelected(i))];
        }

        countFilters(featured = false) {
            return Object.keys(this.Interface.filters).filter(filter => {
                if (featured) {
                    return this.isSelected(filter) && this.isFeatured(filter);
                } else {
                    return this.isSelected(filter);
                }
            }).length;
        }
    }

    /* TYPE FOR SEARCH INTERFACE */
    class Type {
        constructor(Search) { this.Interface = Search; }

        /**
         * Set a type to handle in the result
         * (Product|Category|Page|...)
         * @param type
         * @return {Type}
         */
        add(type) {
            this.Interface.types[type] = true;
            this.Interface.reset();
            return this;
        }

        /**
         * Remove a type to handle in the result
         * (Product|Category|Page|...)
         * @param type
         * @return {Type}
         */
        remove(type) {
            delete this.Interface.types[type];
            this.Interface.reset();
            return this;
        }

        /**
         * Remove all types for search
         * @return {Type}
         */
        reset() {
            this.Interface.types = {};
            this.Interface.reset();
            return this;
        }
    }

    /* SEARCH INTERFACE */
    class Search {
        constructor() {
            /* Configuration */
            this.mode           = 'search';                         /* Mode for this search */
            this.brand          = null;                             /* Brand for this search */
            this.types          = {};                               /* Type of Items we are going to show */
            this.limit          = 0;                                /* Limit the result length (0 will do nothing) */
            this.setSort();

            /* Search */
            this.query          = null;                             /* Search String */
        }

        /* Constants */
        get Observer() { return this._observer || (this._observer = new App.Entities.Observer(this)) }

        /**
         * Retrieve relevant information
         * @return object
         */
        get get() {
            let result = this.result;
            return {
                query:      this.query,
                brand:      this.brand,
                filters:    this.filters,
                types:      this.types,
                total:      this.total,
                count:      result.length,
                sort:       this.sort,
                result:     result,
                filter:     {
                    selected:   this.Filter.countFilters(),
                    featured:   this.Filter.hasFeaturedFilter(),
                },
            };
        }

        /**
         * Retrieve data from Endpoint and apply the first filters to keep the bundle
         * @return array
         */
        get data() {
            if (this._data) return this._data;
            let data = App.Interface.Api.load('search', {}, true, false);
            /* Filter Items only within instances mode */
            data = this.filterMode(data);
            /* Check groups (types) and if item are allowed in search mode */
            data = this.filterType(data);
            return this._data = data;
        }

        /**
         * Retrieve a filtered bundle from the search endpoint
         * @return array
         */
        get result() {
            if (this._result) return this._result;
            let result = this.data;
            /* Filter by selected filters */
            result = this.filterByFilters(result);
            if (this.query) {
                /* Calculate relevance depending on query */
                result = this.setRelevanceByQuery(result);
            }
            result = this.sortResult(result);
            if (this.limit) {
                result = result.slice(0, this.limit);
            }
            return this._result = result;
        }

        async promise() {
            await Promise.all([
                App.Interface.Api.promise('search'),
                App.Interface.Api.promise('search.metadata'),
            ]);
            return this.result;
        }

        /**
         * Retrieve a nicely bundle from groups and its items
         * @return object
         */
        get collection() {
            let result = this.result;
            let collection = {};
            for (let type in this.types) {
                collection[type] = {
                    title:  this.groups[type].label.plural,
                    total:  0,
                    items:  [],
                };
            }
            for(let key in result) {
                let item = result[key];
                if (collection[item.type] !== undefined) {
                    collection[item.type]['items'].push(item);
                    collection[item.type]['total']++;
                }
            }
            return collection;
        }

        /**
         * Return search metadata from Endpoint
         * @return {*}
         */
        get metadata() {
            return this._metadata ||
                (this._metadata = JSON.parse(JSON.stringify(App.Interface.Api.load('search.metadata', {}, true, false))));
        }

        /**
         * Return the total items for the search
         * @return {number}
         */
        get total() {
            return this.data.length;
        }

        /**
         * Return the number of items in the result
         * @return {number}
         */
        get count() {
            return this.result.length;
        }

        /**
         * Return array with every word in a query
         * @return {string[]}
         */
        get queryWords() {
            return this.query.toLowerCase().split(' ');
        }

        /**
         * Return the result groups
         * @return {*}
         */
        get groups() {
            return this.metadata[0];
        }

        /**
         * Return the filter groups
         * @return {*}
         */
        get filterGroups() {
            return this.metadata[1];
        }

        /**
         * Retrieve all filters
         * @return {*}
         */
        get filters() {
            return this.metadata[2];
        }

        /**
         * Retrieve Filter class instance
         * @return {Filter}
         * @constructor
         */
        get Filter() {
            return this._filtering || (this._filtering = new Filter(this));
        }

        /**
         * Retrieve Type class instance
         * @return {Type}
         * @constructor
         */
        get Type() {
            return this._type || (this._type = new Type(this));
        }

        /**
         * Reset data to reload from endpoint again
         */
        reset() {
            this._data = false;
            return this;
        }

        /* MODE */
        setMode(mode) {
            this.mode = mode;
            this.update();
            return this;
        }

        /* BRAND */
        /**
         * Set the actual mode to hable
         * (search|overview|b2b|...)
         * @param mode
         * @return {Search}
         */
        setMode(mode) {
            this.mode = mode;
            this.reset();
            return this;
        }

        /**
         * Set a sort direction if result is not sorted by relevance
         * @param by
         * @param order
         * @return {Search}
         */
        setSort(by = this.Filter.SORT_DEFAULT_BY, order = this.Filter.SORT_DEFAULT_ORDER) {
            if (this.Filter.isSortType(by))
                this.sort = {
                    'by':       by,
                    'order':    order,
                };
            return this;
        }

        /**
         * Set a brand to handle with
         * @param brand
         * @return {Search}
         */
        setBrand(brand) {
            this.brand = brand;
            this.Filter.reset();
            this.update();
            return this;
        }

        /**
         * Set a limit for result
         * @param limit
         * @return {Search}
         */
        setLimit(limit) {
            this.limit = limit;
            this.update();
            return this;
        }

        /**
         * Remove the actual brand
         * The result will retrieve all brands
         * @return {Search}
         */
        removeBrand() {
            this.brand = null;
            this.update();
            return this;
        }

        /**
         * Set and filter the search query
         * @param query
         * @return {Search}
         */
        setQuery(query) {
            if (query) {
                this.setSort('relevance', 'desc');
                this.query = query
                    .trim()
                    .replace(/&/g, '')
                    .replace(/</g, '')
                    .replace(/"/g, '')
                ;
            } else {
                this.query = null;
            }
            this.update();
            return this;
        }

        /**
         * Sort the result after given direction
         * @param result
         * @param by
         * @param order
         * @return {*}
         */
        sortResult(result = this.result, by = this.sort.by, order = this.sort.order) {
            return result.sort((a, b) => {
                let values = {
                    'a': (isNaN(a[by])) ? a[by].toLowerCase() : a[by],
                    'b': (isNaN(b[by])) ? b[by].toLowerCase() : b[by],
                };
                return order === 'desc' ? (values.a > values.b) ? -1 : 1 : (values.a < values.b) ? -1 : 1 ;
            });
        }

        /**
         * Sort result by relevance
         * @param result
         * @return {*}
         */
        setRelevanceByQuery(result) {
            // calculate relevance
            result = Array.from(result).filter(element => {
                let relevance = 0, matches = [];
                return this.queryWords.every(word => {
                    for (var key in element.keywords) {
                        if (key.match(word)) {
                            matches[key] = element.keywords[key];
                            relevance = relevance + element.keywords[key];
                        }
                    }
                    element.matches     = matches;
                    element.relevance   = relevance;
                    return relevance;
                });
            });
            return result;
        }

        /* FILTER RESULT */
        filterMode(result) {
            if (!this.mode) return result;
            return Array.from(result).filter(element => {
                return element['mode'][this.mode] === true
            });
        }

        filterByFilters(result) {
            let filtering = (result, key) => {
                let filter = this.filters[key];
                if (filter === undefined)                       return result;
                return Array.from(result).filter(element => {
                    if (element.filter === undefined)           return false;
                    if (this.isNotFilterRelevant(element.type)) return true;
                    // if Element has this key
                    if (filter.condition === 'exclude')
                        if (!(key in element.filter))           return true;
                    // if Element has not key
                    if (filter.condition === 'include' || filter.condition === 'combine')
                        if (key in element.filter)              return true;
                });
            };
            // combine items
            let combineItems = [];
            this.Filter.combine.forEach(key => combineItems = combineItems.concat(filtering(result, key)));
            if (combineItems.length) result = combineItems;
            // replace items
            for (let key in this.filters) {
                this.filters[key].visibility = this.filters[key].visible;
                if (this.filters[key].selected === true && this.filters[key].condition !== 'combine') {
                    result = filtering(result, key);
                    /* Force visibility if they are selected */
                    this.filters[key].visibility = true;
                }
            }
            /* Update visibility */
            for (let item in result) {
                for (let key in result[item].filter) {
                    if (this.filters[key]) this.filters[key]['visibility'] = true;
                }
            }
            return result;
        }

        filterType(result) {
            if (Object.keys(this.types).length === 0) return result;
            return Array.from(result).filter(
                element => element.type in this.types && element.mode[this.mode]
            );
        }

        /**
         * This are the types that are possible to filter, all other types will be ignore
         * @param type
         * @return {boolean}
         */
        isNotFilterRelevant(type) {
            return ['product', 'design'].indexOf(type) === -1;
        }

        /**
         * return if the search has altered the result
         */
        hasAlteredResult() {
            return this.count !== this.data.length;
        }

        /**
         * Update Interface
         * @return {Search}
         */
        update() {
            this._result = false;
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.Observer.notify();
                this.timeout = 0;
            }, 10);
            return this;
        }
    }
    App.Entities.Search = Search;
})();
